"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b ||= {})
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);

// src/components/AnimatedDiv/index.ts
var AnimatedDiv_exports = {};
__export(AnimatedDiv_exports, {
  AnimatedDiv: () => AnimatedDiv,
  HideAnimation: () => HideAnimation,
  ShowAnimation: () => ShowAnimation
});
module.exports = __toCommonJS(AnimatedDiv_exports);

// src/components/AnimatedDiv/AnimatedDiv.tsx
var import_react2 = __toESM(require("react"));
var import_classnames = __toESM(require("classnames"));

// src/hook/use-delayed-state-hook.ts
var import_react = require("react");
function useDelayedState(dependency, delayDuration = 150) {
  const [state, setState] = (0, import_react.useState)(dependency);
  (0, import_react.useEffect)(() => {
    setTimeout(() => setState(dependency), dependency ? 0 : delayDuration);
  }, [dependency]);
  return state;
}

// src/components/AnimatedDiv/AnimatedDiv.tsx
var ShowAnimation = /* @__PURE__ */ ((ShowAnimation2) => {
  ShowAnimation2["FadeIn"] = "v2-animate-fade-in";
  ShowAnimation2["FadeIn100"] = "v2-animate-fade-in-100";
  ShowAnimation2["FadeIn150"] = "v2-animate-fade-in-150";
  ShowAnimation2["SlideInUp"] = "v2-animate-fade-in-up";
  ShowAnimation2["SlideInUp150"] = "v2-animate-fade-in-up-150";
  ShowAnimation2["SlideInDown"] = "v2-animate-fade-in-down";
  ShowAnimation2["SlideInDown150"] = "v2-animate-fade-in-down-150";
  ShowAnimation2["SlideInLeft"] = "v2-animate-fade-in-left";
  ShowAnimation2["SlideInLeft150"] = "v2-animate-fade-in-left-150";
  ShowAnimation2["SlideInRight"] = "v2-animate-fade-in-right";
  ShowAnimation2["SlideInRight150"] = "v2-animate-fade-in-right-150";
  return ShowAnimation2;
})(ShowAnimation || {});
var HideAnimation = /* @__PURE__ */ ((HideAnimation2) => {
  HideAnimation2["FadeOut"] = "v2-animate-fade-out";
  HideAnimation2["FadeOut100"] = "v2-animate-fade-out-100";
  HideAnimation2["FadeOut150"] = "v2-animate-fade-out-150";
  HideAnimation2["SlideOutUp"] = "v2-animate-fade-out-up";
  HideAnimation2["SlideOutUp150"] = "v2-animate-fade-out-up-150";
  HideAnimation2["SlideOutDown"] = "v2-animate-fade-out-down";
  HideAnimation2["SlideOutDown150"] = "v2-animate-fade-out-down-150";
  HideAnimation2["SlideOutLeft"] = "v2-animate-fade-out-left";
  HideAnimation2["SlideOutLeft150"] = "v2-animate-fade-out-left-150";
  HideAnimation2["SlideOutRight"] = "v2-animate-fade-out-right";
  HideAnimation2["SlideOutRight150"] = "v2-animate-fade-out-right-150";
  return HideAnimation2;
})(HideAnimation || {});
function AnimatedDiv(_a) {
  var _b = _a, {
    show,
    delay = 150,
    children,
    className,
    showAnimation = "v2-animate-fade-in" /* FadeIn */,
    hideAnimation = "v2-animate-fade-out" /* FadeOut */
  } = _b, otherProps = __objRest(_b, [
    "show",
    "delay",
    "children",
    "className",
    "showAnimation",
    "hideAnimation"
  ]);
  const delayedShowState = useDelayedState(show, delay);
  return delayedShowState ? /* @__PURE__ */ import_react2.default.createElement(
    "div",
    __spreadProps(__spreadValues({}, otherProps), {
      className: (0, import_classnames.default)(className, {
        [showAnimation]: show,
        [hideAnimation]: !show
      })
    }),
    children
  ) : /* @__PURE__ */ import_react2.default.createElement(import_react2.default.Fragment, null);
}
